import { useQuery } from '@tanstack/react-query';

import { api, getQueryProps } from 'common';
import { LlmModelLifecycleState } from 'llm-model-registry';

export type ModelLifecycleEntry = api.FlowModelLifecycle.ModelLifecycleEntry;

export const DEPRECATED_STATES = [LlmModelLifecycleState.Retired, LlmModelLifecycleState.Obsolete];

export function useModelLifecycleResult() {
  return useQuery({
    ...getQueryProps(api.client.FlowModelLifecycle, 'findAll', {
      state: [...DEPRECATED_STATES, LlmModelLifecycleState.Upcoming],
    }),
    staleTime: 5 * 60 * 1000, // 5 minutes
    refetchOnWindowFocus: false,
  });
}
